// extracted by mini-css-extract-plugin
export default {"base":"vp_T4oWA","logo":"vp_eKVVs"};